export enum Entities {
  AuthUser = 'user',
  MapGeoJson = 'map-geojson',
  MspInvite = 'msp-invite',
  MspDetails = 'msp-details',
  Countries = 'countries',
  PortlandReport = 'portland-report',
  NetworkAccess = 'network-access',
  Product = 'product',
  MembersAccess = 'members-access',
  ColorPalette = 'color-palette',
  Tags = 'tags',
  EmailTemplates = 'email-templates',
  Plan = 'plan',
  MemberDetails = 'member-details',
  AccessRolesDetails = 'access-roles-details',
  ClientAccessRolesDetails = 'client-access-roles-details',
  CompanySettings = 'company-settings',
  ToolInfo = 'tool-info',
  PracticeTools = 'practice-tools',
  SecurityStackHeaderView = 'security-stack-header-view',
  SecurityStackView = 'security-stack-view',
  TechnologiesByTool = 'technologies-by-tool',
  Tool = 'tool',
  ToolInStack = 'tool-in-stack',
  CategoryProducts = 'category-products',
  StorefrontProducts = 'storefront-products',
  Category = 'category',
  CategorySortOrder = 'category-sort-order',
  CompanyTechSpend = 'company-techspend',
  SuppliersAndManufacturers = 'suppliers-and-manufacturers',
  RecalculateScore = 'recalculate-score',
  Subscription = 'subscription',
}
